import {NgModule} from '@angular/core';
import {ClientInfoService} from './client-info.service';

/**
 * Created by Rodrigo Quesada on 15/03/17.
 */
@NgModule({
    providers: [ClientInfoService]
})
export class ClientInfoModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/client/client-info.module.ts